import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/$locale/validate')({
  component: ValidateLayout,
})

function ValidateLayout() {
  return <Outlet />
}
